export default "__VITE_ASSET__D4VbM2dk__"